import { Box } from "@otrium/core";
import styled from "@emotion/styled";
import { Button } from "src/atoms/Button";

// The content from the CMS will be placed inside the column,
// and we force the styles here regardless of what the user has defined in the CMS.
const Column = styled(Box)`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: ${({ theme }) => theme.fontWeights.heading};
    font-size: ${({ theme }) => theme.fontSizes[2]}px;
    font-family: ${({ theme }) => theme.fonts.heading};
    line-height: 24px;
    text-transform: unset;
    color: ${({ theme }) => theme.colors.tone.black};
  }

  p {
    font-weight: ${({ theme }) => theme.fontWeights.body};
    font-size: ${({ theme }) => theme.fontSizes[0]}px;
    font-family: ${({ theme }) => theme.fonts.body};
    line-height: 20px;
    text-transform: unset;
    color: ${({ theme }) => theme.colors.tone.black};
  }
`;

const StyledButton = styled(Button)`
  margin-top: ${({ theme }) => theme.space[4]}px;
  margin-left: auto;
  margin-right: auto;
`;

export { Column, StyledButton };
